/**
 * Helpers de chemins. L'app est servie sur un sous-domaine dédié, donc `BASE_PATH`
 * est vide — mais les helpers restent obligatoires : si un basePath est introduit un
 * jour, `window.location.href`, les `fetch()` client et les `<img src>` natifs ne sont
 * pas auto-préfixés par Next (voir agents.md §14).
 */

export const BASE_PATH = process.env.NEXT_PUBLIC_BASE_PATH ?? '';

/** Pour un `fetch()` côté client ou un `window.location.href`. */
export function apiUrl(path: string): string {
  return `${BASE_PATH}${path}`;
}

/** Pour un `<img src>` natif ou un `window.open`. */
export function publicAsset(path: string): string {
  return `${BASE_PATH}${path}`;
}

/**
 * Racine des assets publics, base des illustrations d'aide « Comment trouver ? ». Le catalogue
 * porte des chemins relatifs (`help/Windows11.gif`, `etiquette-inventaire-TDS.png`).
 */
export const HELP_MEDIA_BASE = publicAsset('/assets');

/** Bypass d'authentification — dev uniquement, refusé au démarrage en production. */
export const AUTH_BYPASS = process.env.NEXT_PUBLIC_AUTH_BYPASS === 'true';
